import React, { useState } from 'react';
import {
    TextField,
    Button,
    Box,
    Typography,
    Link,
    Divider,
} from '@mui/material';
import { register } from '../api/auth'; // Adjust the path to your API file
import { useNavigate } from 'react-router-dom';

const SignUp = () => {
    const navigate = useNavigate();

    // State for form inputs
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        language: 'en',
    });

    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleRegister = async () => {
        setLoading(true);
        setError('');
        try {
            await register({
                name: formData.firstName + " " + formData.lastName,
                email: formData.email,
                password: formData.password,
            });
            navigate('/signin');
        } catch (err) {
            setError(err.response?.data?.message || 'Registration failed!');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
            bgcolor="#f5f5f5"
        >
            <Box
                width="400px"
                height="-webkit-fill-available"
                bgcolor="#fff"
                p={4}
                borderRadius={2}
                boxShadow="0 4px 20px rgba(0, 0, 0, 0.1)"
            >
                <Typography variant="h5" textAlign="center" fontWeight="bold" gutterBottom>
                    Create Your Account
                </Typography>

                <Box display="flex" gap={2}>
                    <TextField
                        label="First Name"
                        name="firstName"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        size="small"
                        value={formData.firstName}
                        onChange={handleChange}
                    />
                    <TextField
                        label="Last Name"
                        name="lastName"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        size="small"
                        value={formData.lastName}
                        onChange={handleChange}
                    />
                </Box>

                <TextField
                    label="Email"
                    name="email"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    size="small"
                    value={formData.email}
                    onChange={handleChange}
                />

                <TextField
                    label="Password"
                    name="password"
                    type="password"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    size="small"
                    value={formData.password}
                    onChange={handleChange}
                />

                {/* <TextField
                    label="Preferred Language"
                    name="language"
                    select
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    size="small"
                    value={formData.language}
                    onChange={handleChange}
                >
                    <MenuItem value="en">English</MenuItem>
                    <MenuItem value="es">Spanish</MenuItem>
                </TextField> */}

                {error && (
                    <Typography color="error" variant="body2" textAlign="center">
                        {error}
                    </Typography>
                )}

                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleRegister}
                    disabled={loading}
                    sx={{
                        mt: 2,
                        textTransform: 'none',
                        height: '45px',
                        fontWeight: 'bold',
                    }}
                >
                    {loading ? 'Signing Up...' : 'Continue'}
                </Button>

                <Typography variant="body2" textAlign="center" mt={2}>
                    Already have an account?{' '}
                    <Link href="/signin" underline="hover">
                        Sign in here
                    </Link>
                </Typography>
                <Divider sx={{ my: 2, color: "#6876D5" }}></Divider>

            </Box>
        </Box>
    );
};

export default SignUp;
